import { ReactNode } from "react";
import { Box, Typography } from "@mui/material";

export type ChartLoaderProps = {
  isLoading: boolean;
  error?: string;
  children: ReactNode;
};

const pulseAnimation = {
  "@keyframes pulse": {
    "0%": { opacity: 0.5 },
    "50%": { opacity: 0.3 },
    "100%": { opacity: 0.5 },
  },
  animation: "pulse 2s ease-in-out infinite",
};

const errorBoxStyles = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  zIndex: 10,
  backgroundColor: "rgba(255, 255, 255, 0.9)",
  padding: 2,
  borderRadius: 1,
} as const;

export const ChartLoader = ({ isLoading, error, children }: ChartLoaderProps) => {
  return (
    <Box
      sx={{
        position: "relative",
        ...(isLoading && {
          opacity: 0.5,
          ...pulseAnimation,
        }),
      }}
    >
      {error && (
        <Box sx={errorBoxStyles}>
          <Typography color="error" variant="body1">
            {error}
          </Typography>
        </Box>
      )}
      {children}
    </Box>
  );
};
